import { css } from '@emotion/react';
export const LARGE_FEATURE_SHOWCASE_TEXT_CSS = css `
  color: #dfe2e5;
  font-size: 36px;
`;
export const MEDIUM_FEATURE_SHOWCASE_TEXT_CSS = css `
  color: #cccccc;
  font-size: 20px;
`;
